import React, { Component } from 'react'
import { connect } from 'react-redux';

import classnames from "classnames";
import Button from './../shared/Button/index';

import styles from './../../styles/perfect_essay.styl';
import baseStyles from 'custom/base.styl';
import success from './../../img/success@3x.png';

import { profileUpdateStages } from "../../store/profile/actions";

class EssayGenderInMedia extends Component {
  constructor(props) {
    super(props)

    this.state = {
      curStep: 'step1',
    }

    this.onStepClick = this.onStepClick.bind(this)
    this.onComplete = this.onComplete.bind(this)
    this.onStageNext = this.onStageNext.bind(this)
  }

  onStepClick(e) {
    const newStep = e.target.dataset.step;
    // let offsetTop  = e.target.getBoundingClientRect().top;

    this.setState({
      curStep: newStep,
    });
    // e.target.scrollIntoView({ behavior: "smooth" });
    const el = document.getElementById(newStep);
    el.scrollIntoView({ behavior: "smooth" });


    // this.setState({
    //   curStep: newStep,
    // }, () => window.scrollTo({ top: offsetTop, behavior: 'smooth' }));
  }

  onComplete() {
    this.setState({
      curStep: 'finish',
    }, () => window.scrollTo({ top: 0, behavior: 'smooth' }));
  }

  onStageNext() {
    const { nextStage } = this.props;
    nextStage();
    return;
  }

  render() {
    const { curStep } = this.state;

    return (
      <div>
        {/* page-1 */}
        <div className={classnames(styles.perfect_essay)}>

          <div className={classnames(styles.comment_finish, { [styles.active]: curStep === 'finish' })}>
            <img src={success} alt="success" width="100px" />
            <h3>Thank you for completing <br /> the first essay</h3>
						<p>There’s only one test essay left <br /> before you join us as a writer and <br /> start working with real orders. <br /> Show there all your academic <br /> knowledge and writing skills, as we <br /> will check it thoroughly to decide <br /> whether you have passed the <br /> probation.</p>
            <Button onClick={(e) => this.onStageNext(e)} block >Begin the last essay</Button>
          </div>

          <div className={styles.catchword}>Student’s Last Name 1</div>

          <div className={classnames(styles.highlighting, styles.highlighting_type1, { [styles.active]: curStep === 'step1' })} data-step="step1" id="step1">

            <div className={styles.highlighting_content}>
              <header>
                Student’s Name <br />
                Professor’s Name <br />
                Subject <br />
                DD MM YYYY <br />
              </header>

              <div className={styles.center}>Advertisements and Self-Esteem</div>

              <div className={classnames(styles.comment)}>
                <ul>
                  <li>The paper follows the requirements of the MLA formatting style.</li>
                  <li>No personal information is included.</li>
                  <li>Please download a template to avoid mistakes and spend less time on formatting.</li>
                </ul>
                <div className={classnames(styles.btn_wrap, baseStyles.flex_right)}>
                  <button onClick={(e) => this.onStepClick(e)} className={styles.btn} data-step="step2">NEXT&rarr;&nbsp;</button>
                </div>
              </div>

            </div>
          </div>

          <div className={classnames(styles.highlighting, styles.highlighting_type2, { [styles.active]: curStep === 'step2' })} data-step="step2" id="step2">
            <div className={styles.highlighting_content}>
              <p>Mrs Kilbourne argues that advertisers should change their politics of promotion choice, as women’s self-esteem is negatively affected by photoshopped pictures that cause a poor body image and mood deterioration.</p>

              <div className={styles.comment}>
                <ul>
                  <li>The instructions are followed: the paper answers the required question “Discuss how she introduces the issue of self-esteem, why it is such a problem and what other problems can stem from this one, how it can be addressed” explicitly. </li>
                  <li>Structure: The introduction contains an arguable thesis statement.</li>
                  <li>The word count of the introduction is 10%.</li>
                </ul>
                <div className={styles.btn_wrap}>
                  <button onClick={(e) => this.onStepClick(e)} className={styles.btn} data-step="step1">&larr;&nbsp;PREVIOUS</button>
                  <button onClick={(e) => this.onStepClick(e)} className={styles.btn} data-step="step3">NEXT&rarr;&nbsp;</button>
                </div>
              </div>
            </div>
          </div>

          <div className={classnames(styles.highlighting, styles.highlighting_type3, { [styles.active]: curStep === 'step3' })} data-step="step3" id="step3">
            <div className={styles.highlighting_content}>
              <p>In her discussion of the way advertisements affect women, Mrs Kilbourne introduces the issue of the detrimental influence of excessively photoshopped images on women’s self-esteem. Considering mass media to be a credible source of information, women are often led to believe that the models they see in advertisements look the same in real life. This is due to the fact that advertisement images always “dictate what ideal female beauty is” and, being unable to achieve the given standards women feel ashamed and their self-esteem deteriorates (<i>Killing Us Softly</i> 4 5:15-5:25). The problem of poor self-esteem of female due to the photoshopped images is very important because it triggers other psychological issues that might develop into severe diseases.  </p>
              <div className={styles.comment}>
                <ul>
                  <li>Content: The paragraph discusses one idea that is a part of the thesis statement.</li>
                  <li>Structure: The paragraph begins with a topic sentence that explains the main idea. It is followed by the analysis supported with outside information cited in MLA. </li>
                  <li>Language: No personal pronouns, phrasal verbs, contractions, idioms, colloquial language, rhetorical questions are used.</li>
                </ul>
                <div className={styles.btn_wrap}>
                  <button onClick={(e) => this.onStepClick(e)} className={styles.btn} data-step="step2">&larr;&nbsp;PREVIOUS</button>
                  <button onClick={(e) => this.onStepClick(e)} className={styles.btn} data-step="step4">NEXT&rarr;&nbsp;</button>
                </div>
              </div>
            </div>
          </div>

          <div className={classnames(styles.highlighting, styles.highlighting_type4, { [styles.active]: curStep === 'step4' })} data-step="step4" id="step4">
            <div className={styles.highlighting_content}>
              <p>One of the issues that can stem from being often exposed to highly photoshopped female bodies is about being skeptical about one’s own body image. That is to say that when being often exposed to the images of thin-bodied models, women can criticize themselves for looking differently and come to the point of hating their own bodies. Thin-body images can affect one’s self-esteem, body image, and mood (Joshi et al. 333). In order to reverse the problem, media producers need to regulate advertisement politics in an opposite way, i.e. start advertising and promoting beauty standards that coincide with the reality where women do have wrinkles and some extra weight, skin issues, or hair that is not as healthy as one might want to.</p>
              <div className={styles.comment}>
                <ul>
                  <li>Content: The paragraph answers the required question “Why is it such a problem and what other problems can stem from this one, how it can be addressed” explicitly.</li>
                  <li>Word count of the body paragraphs comprise 80% (240 words).</li>
                  <li>Proofreading: No repetitions, misprints, punctuation issues are present in the paper.</li>
                </ul>
                <div className={styles.btn_wrap}>
                  <button onClick={(e) => this.onStepClick(e)} className={styles.btn} data-step="step3">&larr;&nbsp;PREVIOUS</button>
                  <button onClick={(e) => this.onStepClick(e)} className={styles.btn} data-step="step5">NEXT&rarr;&nbsp;</button>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* page-2 */}
        <div className={classnames(styles.perfect_essay)}>
          <div className={styles.catchword}>Student’s Last Name 2</div>

          <div className={classnames(styles.highlighting, styles.highlighting_type1, { [styles.active]: curStep === 'step5' })} data-step="step5" id="step5">
            <div className={styles.highlighting_content}>

              <div className={styles.center}>Works Cited</div>

              <div>Jhally, Sut, director. <i>Killing Us Softly 4: Advertising's Image Of Women,</i> Cambridge </div>
              <p>Documentary Films, Inc., 2010.</p>

              <div>Joshi, Ramona, C. Peter Herman, and Janet Polivy. "Self‐enhancing effects of exposure to </div>
              <p>thin‐body images." International Journal of Eating Disorders 35.3 (2014): 333-341.</p>

              <div className={classnames(styles.comment)}>
                <ul>
                  <li>The minimum requirement to include 1 source per 1 page (300 words) is met.</li>
                  <li>The incorporated source is reliable, the required video is incorporated in the paper.</li>
                  <li>Works Cited page is formatted according to the requirements of the MLA formatting style. </li>
                  <li>The list of sources is alphabetized.</li>
                </ul>
                <div className={styles.btn_wrap}>
                  <button onClick={(e) => this.onStepClick(e)} className={styles.btn} data-step="step4">&larr;&nbsp;PREVIOUS</button>
                  <Button onClick={(e) => this.onComplete(e)} className={styles.btn_finish} light>Finish</Button>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  nextStage: () => dispatch(profileUpdateStages()),
});

export default connect(null, mapDispatchToProps)(EssayGenderInMedia);




// WEBPACK FOOTER //
// ./src/components/PerfectEssay/EssayGenderInMedia.js